import { OverlayLoader } from "components/OverlayLoader";
import { SkeletonTable } from "components/SkeletonTable";

type TableOverlayLoaderProps = {
  columnSize: number;
  pageSize: number;
};

export const TableOverlayLoader = ({ columnSize, pageSize }: TableOverlayLoaderProps) => (
  <>
    <OverlayLoader />
    <SkeletonTable columnSize={columnSize} pageSize={pageSize} />
  </>
);
